/**
 * @generated SignedSource<<85cdac2a90eef73d94a108520e2a3712>>
 * @relayHash 55ce204be1f14dbb581f6712ea734a85
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3f60dedeeef7fe7c5c97115ae89c3b923c69eafac45fb272fb6120c1cbb1c9d8

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useSpaceDirectoryDataSpaceDirectorySpacesQuery$variables = {
  excludeTypes?: string | null | undefined;
  favourite?: boolean | null | undefined;
  first?: number | null | undefined;
  isLicensed: boolean;
  label?: ReadonlyArray<string | null | undefined> | null | undefined;
  name?: string | null | undefined;
  offset?: number | null | undefined;
  status?: string | null | undefined;
  type?: string | null | undefined;
  watching?: boolean | null | undefined;
};
export type useSpaceDirectoryDataSpaceDirectorySpacesQuery$data = {
  readonly spaces: {
    readonly nodes: ReadonlyArray<{
      readonly alias: string | null | undefined;
      readonly currentUser?: {
        readonly isAdmin: boolean;
        readonly isFavourited: boolean;
        readonly isWatched: boolean;
      };
      readonly description: {
        readonly plain: {
          readonly value: string | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly icon: {
        readonly isDefault: boolean | null | undefined;
        readonly path: string;
      } | null | undefined;
      readonly id: string | null | undefined;
      readonly key: string | null | undefined;
      readonly metadata: {
        readonly labels: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null | undefined;
            readonly name: string | null | undefined;
            readonly prefix: string | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
      };
      readonly name: string | null | undefined;
      readonly status: string | null | undefined;
      readonly type: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly pageInfo: {
      readonly endCursor: string | null | undefined;
      readonly hasNextPage: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type useSpaceDirectoryDataSpaceDirectorySpacesQuery = {
  response: useSpaceDirectoryDataSpaceDirectorySpacesQuery$data;
  variables: useSpaceDirectoryDataSpaceDirectorySpacesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "excludeTypes"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "favourite"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isLicensed"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "label"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offset"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "status"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "type"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "watching"
},
v10 = {
  "kind": "ScalarField",
  "name": "id"
},
v11 = {
  "kind": "ScalarField",
  "name": "name"
},
v12 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "excludeTypes",
        "variableName": "excludeTypes"
      },
      {
        "kind": "Variable",
        "name": "favourite",
        "variableName": "favourite"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      },
      {
        "kind": "Variable",
        "name": "label",
        "variableName": "label"
      },
      {
        "kind": "Variable",
        "name": "offset",
        "variableName": "offset"
      },
      {
        "kind": "Variable",
        "name": "spaceNamePattern",
        "variableName": "name"
      },
      {
        "kind": "Variable",
        "name": "status",
        "variableName": "status"
      },
      {
        "kind": "Variable",
        "name": "type",
        "variableName": "type"
      },
      {
        "kind": "Variable",
        "name": "watchedSpacesOnly",
        "variableName": "watching"
      }
    ],
    "concreteType": "PaginatedSpaceList",
    "kind": "LinkedField",
    "name": "spaces",
    "plural": false,
    "selections": [
      {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "alias"
          },
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "kind": "ScalarField",
            "name": "key"
          },
          {
            "concreteType": "Icon",
            "kind": "LinkedField",
            "name": "icon",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "path"
              },
              {
                "kind": "ScalarField",
                "name": "isDefault"
              }
            ]
          },
          {
            "condition": "isLicensed",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "SpaceUserMetadata",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "isAdmin"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isFavourited"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isWatched"
                  }
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "type"
          },
          {
            "kind": "ScalarField",
            "name": "status"
          },
          {
            "concreteType": "SpaceMetadata",
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": [
              {
                "concreteType": "PaginatedLabelList",
                "kind": "LinkedField",
                "name": "labels",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "Label",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v10/*: any*/),
                      (v11/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "prefix"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "SpaceDescriptions",
            "kind": "LinkedField",
            "name": "description",
            "plural": false,
            "selections": [
              {
                "concreteType": "FormattedBody",
                "kind": "LinkedField",
                "name": "plain",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "value"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "hasNextPage"
          },
          {
            "kind": "ScalarField",
            "name": "endCursor"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useSpaceDirectoryDataSpaceDirectorySpacesQuery",
    "selections": (v12/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v5/*: any*/),
      (v8/*: any*/),
      (v0/*: any*/),
      (v7/*: any*/),
      (v4/*: any*/),
      (v9/*: any*/),
      (v1/*: any*/),
      (v6/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "useSpaceDirectoryDataSpaceDirectorySpacesQuery",
    "selections": (v12/*: any*/)
  },
  "params": {
    "cacheID": "55ce204be1f14dbb581f6712ea734a85",
    "id": "3f60dedeeef7fe7c5c97115ae89c3b923c69eafac45fb272fb6120c1cbb1c9d8",
    "metadata": {},
    "name": "useSpaceDirectoryDataSpaceDirectorySpacesQuery",
    "operationKind": "query",
    "text": "query useSpaceDirectoryDataSpaceDirectorySpacesQuery($name:String,$type:String,$excludeTypes:String,$status:String,$label:[String],$watching:Boolean,$favourite:Boolean,$offset:Int,$first:Int,$isLicensed:Boolean!){spaces(spaceNamePattern:$name,type:$type,excludeTypes:$excludeTypes,status:$status,label:$label,watchedSpacesOnly:$watching,favourite:$favourite,offset:$offset,first:$first){nodes{alias,id,name,key,icon{path,isDefault},currentUser@include(if:$isLicensed){isAdmin,isFavourited,isWatched},type,status,metadata{labels{nodes{id,name,prefix}}},description{plain{value}}},pageInfo{hasNextPage,endCursor}}}"
  }
};
})();

(node as any).hash = "c78296108d5e939c972f6c4d3d8519d4";

export default node;
